import React from 'react';
import SEOHead from '../components/shared/SEOHead';
import { getPageSEO } from '../utils/seoConfig';
import StretchableViewPresentation from '../components/presentation-view/StretchableViewPresentation';
import { OutlineProvider } from "../components/presentation-view/OutlineContext";

const StretchablePresentationPage = () => {
  return (
    <>
      <SEOHead seo={getPageSEO("presentationShare")} />
      <OutlineProvider>
        <StretchableViewPresentation />
      </OutlineProvider>
    </>
  );
};

export default StretchablePresentationPage;
